import type { Fighter } from './types';

/**
 * The share of full pace a cursed fighter runs, dashes and attacks at (D-31). Its size is set by
 * measurement, not reasoning: `pnpm --filter @archon3d/tools-balance run calibrate:curse` fights
 * the roster in the arena with one side slowed, and this is the pace at which a curse costs what
 * it costs in Card mode and in Roll (`CURSE_LOG_ODDS`). The arena is far more sensitive to pace
 * than a guess would have it: at 0.8 the slowed side lost 18 points of win chance on average,
 * three times Card's 6. At 0.94, on 16,000 Expert duels of seeds the choice was not made on, it
 * lost 6.0 where Card's factor takes 6.2 from the same fights, a log-odds shift of 0.34 against
 * Card's 0.35 (2026-09-23).
 */
export const CURSE_PACE = 0.94;

/**
 * Slows a fighter for its piece's Curse: slower on its feet, in its dash and between its blows (a
 * burning ring bites less often). Applied once, when the duel is set up.
 */
export function slowFighter(f: Fighter, pace = CURSE_PACE): void {
  f.speed *= pace;
  f.attackInterval /= pace;
  f.pace = (f.pace ?? 1) * pace;
}
